import { memo, useMemo } from 'react';
import { useField } from 'formik';

import { Divider, Grid, Tooltip } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import { InterviewLanguage } from '@synergetx/puppet-interview-types';

import UploadAudioRow from './UploadAudioRow';

interface Props {
    language: InterviewLanguage;
}

const AudioUploadAccordion = ({ language }: Props) => {
    const [, { error }] = useField(`interviewGeneralAudio[${language}]`);
    const hasErrors = useMemo(
        () => error && Object.keys(error as unknown as object).length > 0,
        [error],
    );
    return (
        <Accordion key={language} sx={{ bgcolor: 'background.paper' }}>
            <AccordionSummary
                expandIcon={
                    hasErrors ? (
                        <Tooltip title="Please add missing audio">
                            <ErrorOutlineIcon color="error" />
                        </Tooltip>
                    ) : (
                        <ExpandMoreIcon />
                    )
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{language} General Audio</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
                <Grid container>
                    <UploadAudioRow language={language} audioKeyToSet="meToo" />
                    <UploadAudioRow language={language} audioKeyToSet="thatsLikeMe" />
                    <UploadAudioRow language={language} audioKeyToSet="whichOneOfUs" />
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default memo(AudioUploadAccordion);
